export const CONTENT_BLOCK = {
  blockType: "HTML",
  blockDesign: "HTMLBlock",
  editFormName: "CONTENT_FORM_1",
  html: `<h1>Enter your Content here...</h1>`,
};
